@if (property?.outOfSync) {
    <small class="form-text text-muted">
        <i class="far fa-hand-point-right"></i>
        {{ 'properties.outOfSync' | translation | async }}
        @if (!hasReportedValue) {
            <span>{{ 'properties.reportedValue' | translation | async }}</span>
        } @else {
            {{ 'properties.desiredValue' | translation: { relativeChangeTime, reportedValue: property.reportedValue } | async }}
        }
        <ng-template #reportedValue>{{ 'properties.desiredValue' | translation: { relativeChangeTime, reportedValue: property.reportedValue } | async }}</ng-template>
    </small>
}

@if (property.description) {
    <small id="descriptionBlock" class="form-text text-muted">
        <i class="far fa-hand-point-right"></i>
        {{ property.description }}
    </small>
}

@if ((property.errors?.min || property.errors?.max || property.errors?.pattern) && (property.dirty || property.touched)) {
    <div class="form-text text-danger">
        <i class="fas fa-exclamation-circle"></i>
        {{ property.validationMessage }}
    </div>
}

@if (property.propertyValueMetadata?.error) {
    <div class="form-text text-danger">
        <i class="fas fa-exclamation-circle"></i>
        {{ property.propertyValueMetadata?.error }}
    </div>
}
